import React from 'react';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import submitBanner from '../assets/submit-banner.png';
import { ff } from '../../../theme';

/** Ink card below the board list — the creator-facing entry point into the propose flow. */
const SubmitBountyBanner: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Flex
      as="button"
      type="button"
      w="full"
      textAlign="left"
      p="18px"
      gap="14px"
      align="center"
      borderRadius="20px"
      bg={ff.ink}
      color="white"
      onClick={() => navigate('/bounties/propose')}
    >
      <Box flex={1} minW={0}>
        <Text textStyle="display" fontSize="26px" lineHeight={1.12} color={ff.lime}>Submit a bounty</Text>
        <Text mt="4px" fontSize="13px" lineHeight="1.35" color={ff.faint}>
          Can&apos;t find a company? Submit a referral and we&apos;ll estimate how much you could earn.
        </Text>
      </Box>
      <Image src={submitBanner} alt="" w="52px" h="52px" objectFit="contain" flex="none" />
    </Flex>
  );
};

export default SubmitBountyBanner;
